export const CHANGE_PASSWORD_LOGGED_IN = "CHANGE_PASSWORD_LOGGED_IN"
export const FETCH_USER_EMAIL_ADDRESSES = "FETCH_USER_EMAIL_ADDRESSES"
export const RECEIVE_USER_EMAIL_ADDRESSES = "RECEIVE_USER_EMAIL_ADDRESSES"
export const ADD_USER_EMAIL = "ADD_USER_EMAIL"
export const REMOVE_USER_EMAIL = "REMOVE_USER_EMAIL"
export const FETCH_SUBSCRIPTIONS = "FETCH_SUBSCRIPTIONS"
export const RECEIVE_SUBSCRIPTIONS = "RECEIVE_SUBSCRIPTIONS"
export const SAVE_SUBCRIPTION_SETTINGS = "SAVE_SUBCRIPTION_SETTINGS"
export const UPDATE_ORG_SETTINGS = "UPDATE_ORG_SETTINGS"
export const UPDATE_STRIPE_GIVING = "UPDATE_STRIPE_GIVING"

export const changePasswordLoggedIn = (
  currentPassword,
  newPassword,
  confirmNewPassword,
  success,
  error,
) => ({
  type: CHANGE_PASSWORD_LOGGED_IN,
  currentPassword,
  newPassword,
  confirmNewPassword,
  success,
  error,
})

export const addUserEmail = (payload, success, error) => ({
  type: ADD_USER_EMAIL,
  payload,
  success,
  error,
})

export const removeUserEmail = (email) => ({
  type: REMOVE_USER_EMAIL,
  email,
})

export const receiveUserEmailAddresses = (userEmailAddresses) => ({
  type: RECEIVE_USER_EMAIL_ADDRESSES,
  userEmailAddresses,
})

export const fetchUserEmailAddresses = () => ({
  type: FETCH_USER_EMAIL_ADDRESSES,
})

export const fetchSubscriptions = (success) => ({
  type: FETCH_SUBSCRIPTIONS,
  success,
})

export const receiveSubscriptions = (subscriptions) => ({
  type: RECEIVE_SUBSCRIPTIONS,
  subscriptions,
})

export const saveSubscriptionSettings = (subscriptions, success, error) => ({
  type: SAVE_SUBCRIPTION_SETTINGS,
  subscriptions,
  success,
  error,
})

export const updateOrgSettings = (settings, success, error) => ({
  type: UPDATE_ORG_SETTINGS,
  settings,
  success,
  error,
})

export const updateStripeGiving = (params, success, error) => ({
  type: UPDATE_STRIPE_GIVING,
  params,
  success,
  error,
})
